import React from 'react'
import { renderToString } from 'react-dom/server'
import { toPlainText } from '@portabletext/react'

import JsonLd from 'lib/json-ld/JsonLd'
import QuestionJsonLd from './QuestionJsonLd'

export default class FaqJsonLd extends JsonLd {
  constructor (faqs = []) {
    super('FAQPage')
    if (faqs) {
      this.mainEntity = faqs.map(({ question, answer, sanityAnswer }) => {
        let stringAnswer = answer
        if (React.isValidElement(answer)) {
          stringAnswer = renderToString(answer)
        }
        if (sanityAnswer) {
          stringAnswer = toPlainText(sanityAnswer)
        }
        return QuestionJsonLd.create({ question, answer: stringAnswer })
      })
    }
  }

  static create ({ faqs }) {
    return new FaqJsonLd(faqs)
  }
}
